import {useMemo} from "react";

export const useCountries = (countriesFromApi) => {
  return useMemo(() => {
    if (!Array.isArray(countriesFromApi)) {
      return [];
    }

    return countriesFromApi.map((country) => ({
      ...country,
      name: country.name || "",
    }));
  }, [countriesFromApi]);
};

export const useRegionsByCountry = (countryName, countriesFromApi) => {
  return useMemo(() => {
    if (
      !countryName ||
      !Array.isArray(countriesFromApi) ||
      countriesFromApi.length === 0
    ) {
      return [];
    }

    const lower = (s) => (s ? s.toLowerCase().trim() : "");
    const normalizedCountryName = lower(countryName);

    // Ищем страну по точному совпадению
    let country = countriesFromApi.find(
      (c) => c.name && lower(c.name) === normalizedCountryName,
    );

    // Если не найдено, ищем по частичному совпадению (для случаев типа "United States of America" vs "United States of America (the)")
    if (!country) {
      country = countriesFromApi.find((c) => {
        if (!c.name) return false;
        const normalizedApiName = lower(c.name);
        return (
          normalizedApiName.includes(normalizedCountryName) ||
          normalizedCountryName.includes(normalizedApiName)
        );
      });
    }

    if (
      !country ||
      !country.subdivisions ||
      !Array.isArray(country.subdivisions) ||
      country.subdivisions.length === 0
    ) {
      return [];
    }

    return country.subdivisions.map((subdivision) => ({
      name: subdivision.name || "",
      code: subdivision.code || "",
      geo: subdivision.geo || null,
    }));
  }, [countryName, countriesFromApi]);
};

export const useRegionOptions = (selectedCountryName, countriesFromApi) => {
  const allRegions = useRegionsByCountry(selectedCountryName, countriesFromApi);

  return useMemo(() => {
    return allRegions
      .map((item, idx) => ({
        id: `region-${idx}`,
        name: item.name || "",
        type: "region",
        region: item.name || "",
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [allRegions]);
};
